export const JSBridge = window.JSBridge.default
